'use client'

import React from 'react'
import Link from 'next/link'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { RichText } from '../RichText'
import { trackCtaClicked } from '../../lib/analytics'

interface HeroContentProps {
  welcomeDetail?: any
}

export function HeroContent({ welcomeDetail }: HeroContentProps) {
  return (
    <div className="max-w-3xl flex flex-col justify-center h-full max-md:py-0 py-12 md:py-24 max-md:gap-4 gap-8">
      <div>
        <h1 className="text-4xl sm:text-5xl md:text-6xl text-white leading-[130%] max-w-full md:max-w-none max-md:mb-0 mb-8">
          Get where <span className="font-serif underline italic!">you</span> want to be
        </h1>
      </div>
      {welcomeDetail && (
        <div>
          <RichText
            data={welcomeDetail}
            className="prose prose-invert max-w-full md:max-w-180 [&_p]:text-base [&_p]:md:text-xl [&_p]:text-white [&_p]:leading-relaxed max-md:[&_p]:mb-3 max-md:[&_p:last-child]:mb-0"
          />
        </div>
      )}

      <div className="flex gap-3 md:gap-4 max-md:mt-0 mt-6 md:mt-10 flex-wrap">
        <Link
          href="/consultation"
          onClick={() =>
            trackCtaClicked({
              cta_text: 'Book a Consultation',
              cta_location: 'hero',
              destination_url: '/consultation',
            })
          }
          className="px-5 md:px-8 py-2.5 md:py-4 bg-white text-brand-blue font-semibold rounded-full hover:bg-primary hover:text-white transition-colors flex items-center gap-2 backdrop-blur-sm text-sm md:text-xl"
        >
          Book a Consultation
          <ArrowRight className="w-4 h-4 md:w-5 md:h-5 -translate-y-px" />
        </Link>
      </div>
    </div>
  )
}

export function HeroScrollIndicator() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 1 }}
      className="hidden md:block absolute bottom-8 left-1/2 -translate-x-1/2 z-2 text-center"
    >
      <p className="text-white/80 text-lg mb-2">Scroll to learn more</p>
      <svg
        className="w-6 h-6 mx-auto text-white/70 animate-bounce"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </motion.div>
  )
}
